import { useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ContactFormModal from "./ContactFormModal";

interface CTAButtonProps {
  className?: string;
  children?: React.ReactNode;
}

const CTAButton = ({ className = "", children = "Richiedi preventivo" }: CTAButtonProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const isHomepage = location.pathname === "/";

  const handleClick = useCallback(() => {
    if (isHomepage) {
      const el = document.getElementById("contact");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      setModalOpen(true);
    }
  }, [isHomepage]);

  return (
    <>
      <button type="button" onClick={handleClick} className={className}>
        {children}
      </button>
      {!isHomepage && (
        <ContactFormModal open={modalOpen} onOpenChange={setModalOpen} />
      )}
    </>
  );
};

export default CTAButton;
